import * as React from 'react';
import { useEffect, useState } from 'react';
import { Tabs, Tab, Spinner, View, CardItem, Card, Text, Button, Footer } from 'native-base';
import { DataTable } from 'react-native-paper';
import CalCalDataApi from '../../api/CalCalDataApi';
import useScreenDimensions from '../../hooks/screenDimensions';
import { BarChart, YAxis, XAxis, StackedBarChart, PieChart, Grid } from 'react-native-svg-charts';
import { LinearGradient, Circle, G, Line, Text as SText, Defs, Stop } from 'react-native-svg';
import { isArray } from 'lodash';
import TableRemote from './tableRemote';
import TableLocal from './tableLocal';
import { ScrollView } from 'react-native';

const PieLabels = ({ slices }) => {
	return slices.map((slice, index) => {
		const { labelCentroid, pieCentroid, data } = slice;
		return (
			<G key={`i${index}`}>
				<Line x1={labelCentroid[0]} y1={labelCentroid[1]} x2={pieCentroid[0]} y2={pieCentroid[1]} stroke={data.svg.fill} />
				<Circle cx={labelCentroid[0]} cy={labelCentroid[1]} r={2} fill={data.svg.fill} />
				<SText
					x={labelCentroid[0] + (labelCentroid[0] > pieCentroid[0] - 10 ? 5 : -5)}
					y={labelCentroid[1] + (labelCentroid[1] > pieCentroid[1] ? 2 : -2)}
					fill={data.svg.fill}
					stroke={'black'}
					strokeWidth={0.2}
					textAnchor={labelCentroid[0] > pieCentroid[0] - 10 ? 'start' : 'end'}
					alignmentBaseline={'middle'}
					fontSize={11}>
					{data.label}
				</SText>
			</G>
		);
	});
};

const randomColor = () => {
	return ('#' + ((Math.random() * 0xffffff) << 0).toString(16) + '000000').slice(0, 7);
};

export default function Takings({ navigation, vatReg, filter, jwt, sendPdfUrl }) {
	//decide which cols to show based on screen width

	const [selectedCust, setSelectedCust] = useState();
	const [customers, setCustomers] = useState();
	const { width, height } = useScreenDimensions();

	useEffect(() => {
		sendPdfUrl(`Takings/${filter.taxyear}`);
	}, [filter]);
	const setPdfUrl = tab => {
		sendPdfUrl(tab == 0 ? `Takings/${filter.taxyear}` : `Takings/${filter.taxyear}/byCust`);
	};

	const pieData =
		customers &&
		customers.map((value, index) => ({
			//value,
			amount: Math.max(0, value.payable),
			label: value.display,
			svg: {
				fill: randomColor(),
				onPress: () => (!!selectedCust && value.id == selectedCust.id ? setSelectedCust(null) : setSelectedCust(value)),
				onMouseover: () => console.log(value)
			},
			key: `pie-${index}`
		}));

	return (
		<Tabs
			onScroll={s => {
				s % 1 == 0 && setPdfUrl(s);
			}}
			onChangeTab={({ i }) => setPdfUrl(i)}>
			<Tab heading="All Takings" style={{ height: height - 146 }}>
				<TableRemote
					apiPath="dailyEntries/receipts"
					jwt={jwt}
					cols={[
						{ name: 'expenseDate', title: 'Date', width: 80, sortable: true, renderer: 'date', widthSmall: 70 },
						{ name: 'customer', title: 'Customer', flex: 1, sortable: true },
						{ name: 'description', title: 'Description', flex: 1.5, sortable: true, borderRight: 1, widthSmall: 50 },
						{ name: 'net', title: 'Net', width: 65, numeric: true, visible: vatReg, borderRight: 1, hideSmall: true },
						{ name: 'vat', title: 'Vat', width: 65, numeric: true, visible: vatReg, borderRight: 1, hideSmall: true },
						{ name: 'payable', title: 'Receivable', width: 65, numeric: true, borderRight: 1, widthSmall: 30 },
						{ name: 'paid', title: 'Received', width: 65, numeric: true, borderRight: 1, widthSmall: 30 },
						{ name: 'account', title: 'Method', flex: 0.7, sortable: true, style: { marginLeft: 10 } }
					]}
					filter={filter && filter.taxyear}
					rowAlt="#EDEDED"
				/>
				{/*<DataTable.Pagination
						page={1}
						numberOfPages={3}
						onPageChange={page => {
							console.log(page);
						}}
						label="1-2 of 6"
					/>*/}
			</Tab>
			<Tab heading="By Customer" style={{ height: height - 146 }}>
				{!selectedCust && (
					<ScrollView>
						<CardItem bordered>
							<Text>Select a customer</Text>
						</CardItem>
						<CardItem bordered style={{ flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-around' }}>
							<View style={{ flexBasis: 400, justifyContent: 'center', alignSelf: 'center', alignItems: 'center' }}>
								{customers && (
									<PieChart
										style={{ height: 300, width: 400, alignSelf: 'center', overflow: 'visible' }}
										valueAccessor={({ item }) => item.amount} // 4.0.0 only relies on react-native-svg@^6.2.1
										data={pieData}
										animate
										contentInset={{ top: 10, left: 50, right: 50, bottom: 10 }}
										spacing={0}
										innerRadius={20}
										outerRadius={70}
										labelRadius={80}>
										<PieLabels />
									</PieChart>
								)}
							</View>
							<View style={{ flexBasis: 400, flexShrink: 1 }}>
								<TableLocal
									jwt={jwt}
									cols={[
										{ name: 'display', title: 'Name', flex: 1.5, sortable: true },
										{ name: 'payable', title: 'Receivable', numeric: true, flex: 1, sortable: true },
										{ name: 'paid', title: 'Received', numeric: true, flex: 1, sortable: true },
										{ name: 'numTrans', title: 'No. Transactions', numeric: true, flex: 1, sortable: true }
									]}
									apiPath="customers/byYear"
									filter={filter && filter.taxyear}
									onDataChange={setCustomers}
									rowAlt="#EEEEEF"
									selected={selectedCust}
									onSelect={cust => (!!selectedCust && cust.id == selectedCust.id ? setSelectedCust(null) : setSelectedCust(cust))}
								/>
							</View>
						</CardItem>
					</ScrollView>
				)}
				{!!selectedCust && (
					<>
						<CardItem bordered>
							<Text>{selectedCust.display}'s transactions</Text>
							<Button bordered onPress={() => setSelectedCust(null)} style={{ marginHorizontal: 20 }} small>
								<Text>Back</Text>
							</Button>
						</CardItem>
						<View style={{ flex: 1 }}>
							<TableRemote
								apiPath="dailyEntries/byCustomer"
								jwt={jwt}
								cols={[
									{ name: 'expenseDate', title: 'Date', width: 80, sortable: true, renderer: 'date' },
									{ name: 'description', title: 'Description', flex: 1.5, sortable: true },
									{ name: 'net', title: 'Net', width: 50, numeric: true, visible: vatReg },
									{ name: 'vat', title: 'Vat', width: 50, numeric: true, visible: vatReg },
									{ name: 'payable', title: 'Receivable', width: 50, numeric: true },
									{ name: 'paid', title: 'Received', width: 80, numeric: true }
								]}
								filter={`${selectedCust.id}/year:${filter.taxyear}`}
								rowAlt="#EDEDED"
							/>
						</View>
					</>
				)}
			</Tab>
		</Tabs>
	);
}
